import { Sparkles } from "lucide-react";

interface ComingSoonProps {
  feature: string;
}

export function ComingSoon({ feature }: ComingSoonProps) {
  return (
    <div className="p-6 border shadow-lg rounded-2xl bg-background/70 dark:bg-zinc-900/80 backdrop-blur text-center">
      <div className="max-w-md mx-auto">
        <div className="w-12 h-12 mx-auto mb-4 bg-primary/10 rounded-lg flex items-center justify-center">
          <Sparkles className="w-6 h-6 text-primary" />
        </div>
        <h3 className="text-lg font-bold text-gray-900 dark:text-gray-100 mb-2">
          Coming Soon
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          {feature} instructions will be available soon.
        </p>
      </div>
    </div>
  );
}
